<!-- Accept request Modal Starts -->
<app-modal [modalId]="'accept-request'" [modalContentId]="'acceptRequestContent'"
  [showCloseAlert]="form.dirty || (action==='edit' && roleDeleted)" [modalSize]="'small'" (closeEvent)="onCancel()"
  (mouseLeaveEvent)="mouseLeave()">
  <modal-div class="title-text">
    Review Request
  </modal-div>

  <modal-div class="body-content">
    <form [formGroup]="form">
      <div class="row">
        <div class="form-group col-lg-12 col-sm-12 mb-0">
          <p class="modal--info-txt font-bold" id="acceptRequestContent">You are about to grant permission for the
            project.
            You might want to review the project type.</p>

          <ng-container *ngIf="action==='accept'">
            <p class="font-bold mb-0">Project Name</p>
            <p *ngIf="action==='accept'">{{currentUser?.project_name}}</p>
          </ng-container>

          <ng-container *ngIf="action==='edit'">
            <label id="associatedProjectLabel" for="associated-taxonomy" class="font-bold">Project Name <span class="mandatory">*</span></label>
            <select class="custom-select" required id="associated-taxonomy" [(ngModel)]="selectedProject"
              (change)="selectProject()" formControlName="project_dd" name="project_d22d"
              aria-labelledby="associatedProjectLabel associatedProjectHelp">
              <option *ngFor="let project of projects" [ngValue]="project">{{ project.projectName }}</option>
            </select>
            <p id="associatedProjectHelp" class="form-text text-muted text-right">You can change the project for which
              the
              access to be granted.</p>
          </ng-container>

        </div>

        <div class="form-group col-lg-12 col-sm-12 mb-0">
          <ng-container *ngIf="action==='accept'">
            <p class="font-bold mb-0">Role</p>
            <div class="row" *ngFor="let role of selectedRole">
              <div class="col-12">
                <p class="mb-0">{{role.roleName}}</p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="action==='edit'">
            <label id="associatedRoleLabel" for="assignRole" class="font-bold">Role <span class="mandatory">*</span></label>
            <select *ngIf="action==='edit'" class="custom-select" required id="assignRole" formControlName="role_dd"
              (change)="selectRole($event.target.value)" id="selectDefaultRole1" [(ngModel)]="defaultRole" aria-labelledby="associatedRoleLabel associatedRoleHelp">
              <option value="null" id="selectDefaultRole" selected>Select Role</option>
              <option value="{{ role.roleId }}#||#{{ role.roleName }}" *ngFor="let role of roles">{{ role.roleName }}
              </option>
            </select>
            <p id="associatedRoleHelp" class="form-text text-muted text-right">You can change the role the user has
              requested
              for.
            </p>
          </ng-container>

        </div>
      </div>
    </form>

    <div class="data-collection-list" *ngIf="action==='edit'">
      <div class="row show-data" *ngFor="let role of selectedRole">
        <div class="col-lg-11 col-sm-11">
          <p class="mb-0">{{role.roleName}}</p>
        </div>
        <div class="col-lg-1 col-sm-1 text-right">
          <button class="btn btn-icon tooltip top lg position-relative d-inline-block" data-tooltip="Delete role"
            (click)="deleteRole(role);" [attr.aria-label]="role?.roleName + ' Delete'">
            <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
          </button>
        </div>
      </div>
    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button *ngIf="action==='accept'" type="button" class="btn btn-primary btn-sm" id="acceptBtn"
      (click)="actionOnRequest('accept', $event)" data-dismiss="modal">Accept </button>
    <button *ngIf="action==='edit'" [disabled]="!enableEdit" type="button" class="btn btn-primary btn-sm" id="editBtn"
      (click)="actionOnRequest('accept', $event)" data-dismiss="modal"> Edit
    </button>
  </modal-div>
</app-modal>
<!-- Accept request Modal Ends -->

<!-- Decline request Modal Starts -->
<app-modal [modalId]="'decline-request'" [modalContentId]="'declineRequestContent'" [showCloseAlert]="declineForm.dirty"
  [modalSize]="'small'" (closeEvent)="onCancel()">
  <modal-div class="title-text">
    Decline Request
  </modal-div>

  <modal-div class="body-content">

    <div class="row">
      <div class="col-12 p-0">
        <form [formGroup]="declineForm">
          <div class="form-group col-lg-12 col-sm-12 mb-0">
            <p class="modal--info-txt font-bold" id="declineRequestContent">You are about to decline the request for a
              project.</p>
            <p class="font-bold mb-0">Project Name</p>
            <p id="projectName">{{currentUser?.project_name}}</p>
          </div>

          <div class="form-group col-lg-12 col-sm-12">
            <label for="declineReason" class="font-bold" id="textDecline">Reason</label>
            <textarea class="form-control font-bold" id="declineReason" placeholder="" rows="3" formControlName="reason"
              [(ngModel)]="comment" aria-labelledby="textDecline textDeclineContent"></textarea>
            <p class="form-text text-muted text-right" id="textDeclineContent">You may provide a reason for declining the request.</p>
          </div>
        </form>
      </div>
    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button type="button" class="btn btn-primary btn-sm" (click)="actionOnRequest('decline', $event)" id="DeclineBtn"
      data-dismiss="modal">Decline</button>
  </modal-div>
</app-modal>
<!-- Decline request Modal Ends -->

<!-- User profile Modal Starts -->
<app-modal [modalId]="'user-profile'" [modalContentId]="'userProfileContent'" [showCloseAlert]="false"
  [showCancelBtn]="false" [modalSize]="'small'" [showFooter]="false" (closeEvent)="onCancel()"
  (mouseLeaveEvent)="mouseLeave()">
  <modal-div class="title-text">
    User Profile
  </modal-div>

  <modal-div class="body-content">
    <div class="profile text-center" id="userProfileContent" *ngIf="currentUser">
      <span class="profile-image"><img src="assets/images/profile.png" class="img-fluid" alt="Profile-pic" /></span>
      <h3 class="font-bold">{{currentUser.user_name}}</h3>
      <p class="profile-email m-0">{{currentUser.user_email}}</p>
      <p class="profile-role mt-2">{{currentUser.workflow_stage_roles}}</p>
    </div>
  </modal-div>

</app-modal>
<!-- User profile Modal Ends -->

<div class="row justify-content-between mx-0">
  <div class="form-group col-2">
    <label for="selectedRequestType" class="sr-only">
      Project Request </label>
    <select id="selectedRequestType" [(ngModel)]="selectedRequestType" [ngModelOptions]="{standalone: true}"
      class="custom-select" aria-describedby="instructionTxt">
      <option [ngValue]="'pending'">Pending</option>
      <option [ngValue]="'approved'">Approved</option>
      <option [ngValue]="'declined'">Declined</option>
    </select>
    <p class="sr-only m-0" id="instructionTxt">The result below will be filtered as soon as new value is selected from
      the combobox.</p>
  </div>
</div>

<app-data-table
    *ngIf="selectedRequestType==='pending'"
    [showMenu]="true"
    [columnList]="listOfColumn_pr"
    [dataSet]="pending"
    [tableCategory]="'Project-requests notification'"
    (showData)="getCurrentRequestDetails($event)"
    [optionList]="optionList"
    (clickedOption)="onOptionClicked($event)"
    (indexEvent)="getIndex($event)">
  </app-data-table>
<app-data-table *ngIf="selectedRequestType==='approved'" [showMenu]="false" [columnList]="listOfColumn_aprvd"
  [dataSet]="approved" [tableCategory]="'Approved notification'" (showData)="getCurrentRequestDetails($event)">
</app-data-table>
<app-data-table
    *ngIf="selectedRequestType==='declined'"
    [tableCategory]="'Declined notification'"
    [showMenu]="true"
    [columnList]="listOfColumn_dclnd"
    [dataSet]="declined" [optionList]="optionList_declined"
    (showData)="getCurrentRequestDetails($event)"
    (clickedOption)="onOptionClicked($event)"
    (indexEvent)="getIndex($event)">
</app-data-table>